module.exports = __webpack_public_path__ + "static/media/om.0e22e9d8.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/om.svg
// module id = 2182
// module chunks = 0